"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StarIcon = void 0;
/* eslint-disable max-len */
var react_1 = __importStar(require("react"));
var Icon_1 = require("./Icon");
exports.StarIcon = (0, react_1.forwardRef)(function StarIcon(props, ref) {
    return (react_1.default.createElement(Icon_1.Icon, __assign({ ref: ref, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { 
            // eslint-disable-next-line max-len
            d: "M11.9998 17.3283L6.59679 20.6143C6.47044 20.6913 6.32417 20.7291 6.17637 20.7231C6.02856 20.7172 5.88583 20.6676 5.76611 20.5807C5.6464 20.4938 5.55506 20.3735 5.50358 20.2348C5.4521 20.0961 5.44278 19.9453 5.47679 19.8013L6.93279 13.6463L2.13679 9.52333C2.02468 9.42686 1.94359 9.2994 1.90373 9.15698C1.86387 9.01455 1.86701 8.86352 1.91275 8.72287C1.95849 8.58222 2.0448 8.45824 2.16081 8.36651C2.27683 8.27478 2.41738 8.2194 2.56479 8.20733L8.86779 7.69033L11.3078 1.85533C11.3648 1.71884 11.461 1.60226 11.5841 1.52027C11.7072 1.43828 11.8519 1.39453 11.9998 1.39453C12.1477 1.39453 12.2923 1.43828 12.4155 1.52027C12.5386 1.60226 12.6347 1.71884 12.6918 1.85533L15.1318 7.69033L21.4348 8.20733C21.5821 8.21957 21.7225 8.27508 21.8384 8.36688C21.9543 8.45868 22.0404 8.58267 22.0861 8.72329C22.1317 8.8639 22.1347 9.01486 22.0948 9.15721C22.0549 9.29955 21.9739 9.42693 21.8618 9.52333L17.0668 13.6463L18.5228 19.8013C18.5568 19.9453 18.5475 20.0961 18.496 20.2348C18.4445 20.3735 18.3532 20.4938 18.2335 20.5807C18.1137 20.6676 17.971 20.7172 17.8232 20.7231C17.6754 20.7291 17.5291 20.6913 17.4028 20.6143L11.9998 17.3283Z", fill: "currentColor" })));
});
